"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsButtonStyle = void 0;
const typestyle_1 = require("typestyle");
const menuStyle = () => ({
    display: 'none',
    position: 'absolute',
    left: '-38px',
    bottom: '48px',
    padding: '2px 6px',
    fontSize: '14px',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    flexFlow: 'column',
    minWidth: '180px',
    maxHeight: 'calc(100vh - 110px)',
    overflowY: 'auto'
});
const menuItemStyle = () => ({
    cursor: 'pointer',
    margin: '4px 0',
    padding: '4px',
    $nest: {
        '&:last-child': {
            marginTop: 0
        },
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
        }
    }
});
exports.SettingsButtonStyle = (0, typestyle_1.stylesheet)({
    settings: {
        position: 'relative'
    },
    menu: Object.assign({}, menuStyle()),
    menuOpen: Object.assign(Object.assign({}, menuStyle()), { display: 'flex' }),
    menuItemTitle: {
        padding: '6px 4px',
        borderBottom: '1px solid white',
        fontWeight: 'bold'
    },
    menuItem: Object.assign({}, menuItemStyle()),
    menuItemSelected: Object.assign(Object.assign({}, menuItemStyle()), { backgroundColor: 'rgba(255, 255, 255, 0.2) !important' }),
    button: {
        width: '32px',
        height: '32px',
        padding: '5px'
    }
});
